import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { ToastController,App } from 'ionic-angular';

import { Utils } from './utils';
import { APP_WEBSERVICE_URL } from '../config/constants';
import { ToastAlert } from '../util/toastalert';
import { ErrorPage } from '../../pages/error/error';

@Injectable()
export class WebService {
	
	constructor(public http: Http,public toastCtrl: ToastController,public toastAlert:ToastAlert,public appCtrl: App) {
    }
	
	/**
	 * webservice请求   全post请求  
	 */
	public post(urlKey:string,params:any,funName:string):Promise<any>{
		let headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
     	return this.http.post(APP_WEBSERVICE_URL, this.toBodyString(this.handleParams(urlKey,params,funName)), new RequestOptions({headers: headers}))
		       .toPromise()
		       .then(response => this.handleSuccess(response.json())) 
		       .catch(error => this.handleError(error));
	}
	
	/**
	 * 处理即将传送到后台的参数  this.handleParams(urlKey,params)
	 */
    private handleParams(urlKey:string,params:any,funName:string){
    	var timeslong = new Date().getTime();//当前时间戳
    	var reqparams = {'urlKey':urlKey,'funName':Utils.base64Encode(funName),'params':Utils.base64Encode(this.toQueryString(params)+timeslong+200)};
		return reqparams;
	}
    
    private handleSuccess(response: any)  {
    	if(response.constructor==String){//如果出现返回的json为string类型,手动将字符串转换为json格式
    		response = JSON.parse(response);
    	}
    	if(response.code=='1000'||response.code=='200'){//请求数据成功
    		//this.alertMsg(response.msg,'middle',1000);
    		return response.obj;
    	}else{//请求数据失败
    		this.toastAlert.alertMsg(response.error,'middle',1000);
    		//alert(response.error);//提示错误信息,弹窗后续修改
    		return null;
    	}
   }
   
 	private handleError(error: any)  {
	     let msg = '请求失败';
	     if (error.status == 0) {
	       msg = '请求地址错误';
	     }
	     if (error.status == 400) {
	       msg = '请求无效';
	       console.log('请检查参数类型是否匹配');
	     }
	     if (error.status == 404) {
	       msg = '请求资源不存在';
	       console.error(msg+'，请检查路径是否正确');
	     }
	     if (error.status == 500) {
	       msg = '请求内部出错';
	       console.error(msg+'，请检查程序是否正确');
	     }
	     console.log(error);
	     //alert(msg);//这里使用ToastController
	     //this.toastAlert.alertMsg(msg,'middle',1000);
	     //return {success: false, msg: msg};
	     this.appCtrl.getRootNav().push(ErrorPage, { errorMsg:msg});
	     
   }
  
    
	/**
    * @param obj　参数对象
    * @return {string}　参数字符串
    * @example
    *  声明: var obj= {'name':'小军',age:23};
    *  调用: toQueryString(obj);
    *  返回: "name=小军&age=23"
    */
   private toQueryString(obj) {
     let ret = [];
     for (let key in obj) {
       key = encodeURIComponent(key);
       let values = obj[key];
       if (values && values.constructor == Array) {//数组
         let queryValues = [];
         for (let i = 0, len = values.length, value; i < len; i++) {
           value = values[i];
           queryValues.push(key + '=' + (values === null ? '' : String(values)));
         }
         ret = ret.concat(queryValues);
       } else { //字符串
         ret.push(key + '=' + (values === null ? '' : String(values)));
       }
    }
     return ret.join('&');
   }
   
   /**
    *
    * @param obj
    * @return {string}
    *  声明: var obj= {'name':'小军',age:23};
    *  调用: toQueryString(obj);
    *  返回: "name=%E5%B0%8F%E5%86%9B&age=23"
    */
   private toBodyString(obj) {
     let ret = [];
     for (let key in obj) {
       key = encodeURIComponent(key);
       let values = obj[key];
       if (values && values.constructor == Array) {//数组
         let queryValues = [];
         for (let i = 0, len = values.length, value; i < len; i++) {
           value = values[i];
           queryValues.push(this.toQueryPair(key, value));
         }
         ret = ret.concat(queryValues);
       } else { //字符串
         ret.push(this.toQueryPair(key, values));
       }
     }
     return ret.join('&');
   }
   
    private toQueryPair(key, value) {
     if (typeof value == 'undefined') {
       return key;
     }
     return key + '=' + encodeURIComponent(value === null ? '' : String(value));
   }  
   
}


// WEBPACK FOOTER //
// ./src/providers/service/webservice.ts